/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import {
  Panel,
  Table,
  Label,
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import subDays from 'date-fns/sub_days';
import format from 'date-fns/format';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import PageSizer from 'loracoms/PageSizer';
import RichLabel from 'loracoms/RichLabel';
import ShowIf from 'loracoms/ShowIf';
import PanelToolbar from 'loracoms/PanelToolbar';
import DatePicker from 'loracoms/DatePicker';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  getGatewayLog,
  getGatewayLogRecord,
} from 'loraapi/lora_gateway';
import { normalizeMac } from 'lorautils/IdUtils';
import styles from './styles.scss';


function defaultFrom() {
  return startOfDay(subDays(new Date(), 7));
}

function defaultTo() {
  return endOfDay(new Date());
}

const defaultProps = {
  gatewayId: null,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  gatewayId: React.PropTypes.string,
  pushState: React.PropTypes.func.isRequired,
};

class GatewayLog extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pageSize: 50,
    };
    this.loadLogs = this.loadLogs.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaylog');
  }

  componentDidMount() {
    this.loadLogs();
  }

  loadLogs(args) {
    let {
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;
    if (_.has(args, 'from')) {
      from = args.from;
    }
    if (_.has(args, 'to')) {
      to = args.to;
    }
    const params = _.extend({
      limit: this.state.pageSize,
      after: from.valueOf(),
      before: to.valueOf(),
      order: 'desc',
    }, args);

    let promise = null;
    if (_.isNil(this.props.gatewayId)) {
      promise = getGatewayLog(params);
    } else {
      promise = getGatewayLogRecord(params, this.props.gatewayId);
    }

    promise.then((res) => {
      const list = _.map(res.body.list, (l) => {
        if (!_.isNull(l.info)) {
          const info = _.join(_.map(_.toPairs(l.info), e => `${e[0]}:${e[1]}`), ',');
          return { ...l, info };
        }
        return l;
      });
      this.setState({ list });
    }).catch(() => {});
  }

  handleChangeFrom(from) {
    const to = endOfDay(from);
    this.setState({ from: startOfDay(from), to });
    this.loadLogs({ from: startOfDay(from), to });
  }

  handleChangeTo(to) {
    this.setState({ to: endOfDay(to) });
    this.loadLogs({ to: endOfDay(to) });
  }

  handleChangePageSize(ps) {
    this.setState({ pageSize: ps });
    this.loadLogs({ limit: ps });
  }

  render() {
    const { gatewayId, pushState } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
      pageSize = 50,
      list,
    } = this.state;

    const LogLevels = {
      info: <Label bsStyle="info">INFO</Label>,
      warn: <Label bsStyle="warning">WARN</Label>,
      debug: <Label bsStyle="default">DEBUG</Label>,
      INFO: <Label bsStyle="info">INFO</Label>,
    };

    const fromPicker = <DatePicker date={from} onSelect={this.handleChangeFrom} />;
    const toPicker = (
      <DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => GatewayLog.handleDisableDate(d, from)}
      />
    );

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('thead.panelheader')}>
        <PanelToolbar tools={[fromPicker, toPicker]} />
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('thead.cat')}</th>
              <th>{this.intlMsg.msg('thead.time')}</th>
              <ShowIf if={_.isNil(gatewayId)}>
                <th>{this.intlMsg.msg('thead.mac')}</th>
              </ShowIf>
              <th>{this.intlMsg.msg('thead.code')}</th>
              <th>{this.intlMsg.msg('thead.message')}</th>
            </tr>
          </thead>
          <tbody>
            {
              list.map((r, idx) => (
                <tr key={String(idx)}>
                  <td>{LogLevels[r.cat]}</td>
                  <td>
                    {format(r.$time, 'YYYY-MM-DD HH:mm:ss')}
                  </td>
                  <ShowIf if={_.isNil(gatewayId)}>
                    <td>
                      <Link onClick={() => pushState(`gateway/detail/${r.gateway}/log`)}>
                        {normalizeMac(r.gateway)}
                      </Link>
                    </td>
                  </ShowIf>
                  <td>
                    <RichLabel
                      content={r.code}
                      enums={[{
                        content: 'GATEWAYCONNECTED',
                        theme: 'green',
                      }, {
                        content: 'GATEWAYDISCONNECTED',
                        theme: 'red',
                      }, {
                        content: 'CONFLICTCONNECTION',
                        theme: 'yellow',
                      }]}
                    />
                  </td>
                  <td>{r.info}</td>
                </tr>
              ))
            }
          </tbody>
        </Table>
        <ShowIf if={list.length > 0}>
          <div className={styles.pager}>
            <PageSizer
              pageSize={pageSize}
              onChange={this.handleChangePageSize}
              options={[50, 100, 500]}
            />
          </div>
        </ShowIf>
        <ShowIf if={list.length === 0}>
          <div className={styles.noData}>
            <h3>{this.intlMsg.msg('nodata')}</h3>
          </div>
        </ShowIf>
      </Panel>
    );
  }
}

GatewayLog.defaultProps = defaultProps;
GatewayLog.propTypes = propTypes;


export default connect(
  () => ({}),
  { pushState: routerActions.push },
)(injectIntl(GatewayLog));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayLog/index.jsx